import { Modal, Button } from "react-bootstrap";
import "./style.scss";
import DBModal from "../DBModal";
import DBButton from "../DBButton";
import { t } from "i18next";

export default function DBComingSoonModal({
    show,
    onHide,
    btnTitle,
    onConfirm,
    title,
    description,
    loading,
    hideCancelBtn,
    minWidth,
}) {
    return (
        <DBModal
            show={!!show}
            onHide={onHide}
            permanent
            className="db-coming-soon-modal"
            minWidth={400}
        >
            <DBModal.Content>
                <h4>{title}</h4>
                <p>{description}</p>
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    caption={t("ok")}
                    style={{ width: "100%" }}
                    onClick={onHide}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
